import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import axios from 'axios'
import store from './store'
import ServerError from './components/Common/500'
import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
Vue.component('ServerError', ServerError)

Vue.config.productionTip = false

// axios.defaults.baseURL = 'http://65.0.180.156';
// Vue.prototype.baseURL = "http://65.0.180.156"
// Vue.prototype.mediaURL = "http://65.0.180.156/wp/"

// axios.defaults.baseURL = 'http://192.168.55.41:3700';
// Vue.prototype.baseURL = "http://192.168.55.41:3700"
// Vue.prototype.mediaURL = "http://192.168.55.41:3700/wp/"
// Vue.prototype.mediaUURL = "http://192.168.55.41:3700/u/"

//  local Production
// axios.defaults.baseURL = 'https://r0z2fx1p-3700.inc1.devtunnels.ms';
// Vue.prototype.baseURL = "https://r0z2fx1p-3700.inc1.devtunnels.ms"
// Vue.prototype.mediaURL = "https://r0z2fx1p-3700.inc1.devtunnels.ms/wp/"
// Vue.prototype.mediaUURL = "https://r0z2fx1p-3700.inc1.devtunnels.ms/u/"

// // Local Development
// axios.defaults.baseURL = 'https://r0z2fx1p-3701.inc1.devtunnels.ms';
// Vue.prototype.baseURL = "https://r0z2fx1p-3701.inc1.devtunnels.ms"
// Vue.prototype.mediaURL = "https://r0z2fx1p-3701.inc1.devtunnels.ms/wp/"
// Vue.prototype.mediaUURL = "https://r0z2fx1p-3701.inc1.devtunnels.ms/u/"


axios.defaults.baseURL = 'https://apikl06farm.leopardtechlabs.in';
Vue.prototype.baseURL = "https://apikl06farm.leopardtechlabs.in"
Vue.prototype.mediaURL = "https://apikl06farm.leopardtechlabs.in/wp/"
Vue.prototype.mediaUURL = "https://apikl06farm.leopardtechlabs.in/u/"

// axios.defaults.baseURL = 'https://api-dev.kl06.co.in';
// Vue.prototype.baseURL = "https://api-dev.kl06.co.in"
// Vue.prototype.mediaURL = "https://api-dev.kl06.co.in/wp/"
// Vue.prototype.mediaUURL = "https://api-dev.kl06.co.in/u/"



new Vue({
    vuetify,
    router,
    store,


    render: h => h(App)
}).$mount('#app')